// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseTypeEntity from './entities/case-type.json';
import caseTypeMenu from '../pages/case-type/menu.json';
import caseTypeFullForm from '../pages/case-type/forms/full.json';
import caseTypeContextForm from '../pages/case-type/forms/context.json';
import caseTypeMiniForm from '../pages/case-type/forms/mini.json';
import caseTypeLookupForm from '../pages/case-type/forms/lookup.json';
import caseTypeTableView from '../pages/case-type/views/table.json';
import caseTypeDashboardView from '../pages/case-type/views/dashboard.json';

/** Тип запису «Тип справи» зі сторінками пакета: меню, форми та подання з pages/case-type/. */
export const caseTypeDefinition: IRecordTypeDefinition = {
  ...caseTypeEntity,
  views: assembleViewSet({
      table: caseTypeTableView,
      dashboard: caseTypeDashboardView,
  }),
  form: caseTypeFullForm,
  forms: { full: caseTypeFullForm, context: caseTypeContextForm, mini: caseTypeMiniForm, lookup: caseTypeLookupForm },
  menu: caseTypeMenu,
} as IRecordTypeDefinition;
